"use client";

import { Calendar, Clock, MapPin } from "lucide-react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
export default function MemorableEventPlanning() {
  const {
    ref: headerRef,
    isVisible: headerVisible
  } = useRevealOnScroll({
    threshold: 0.2
  });
  const {
    ref: card1Ref,
    isVisible: card1Visible
  } = useRevealOnScroll({
    threshold: 0.15
  });
  const {
    ref: card2Ref,
    isVisible: card2Visible
  } = useRevealOnScroll({
    threshold: 0.15
  });
  const {
    ref: card3Ref,
    isVisible: card3Visible
  } = useRevealOnScroll({
    threshold: 0.15
  });
  const scheduleItems = [{
    time: "9:00 AM - 10:30 AM",
    title: "Registration & Welcome Coffee",
    location: "Main Lobby",
    icon: Clock
  }, {
    time: "11:00 AM - 1:00 PM",
    title: "Opening Keynote & Panel Discussion",
    location: "Grand Hall",
    icon: Calendar
  }, {
    time: "2:00 PM - 5:00 PM",
    title: "Networking Reception & Live Entertainment",
    location: "Rooftop Terrace",
    icon: MapPin
  }];
  return <section className="relative min-h-screen overflow-hidden bg-dark-background py-16 md:py-24">
      {}
      <div className="absolute inset-0 bg-cover bg-center bg-[url(https://wpvc-images.s3.us-east-1.amazonaws.com/images/1438489/img/event_venue_wide_hall.png)] opacity-30" aria-hidden="true" />

      {}
      <div className="pointer-events-none absolute inset-0" aria-hidden="true">
        {[...Array(20)].map((_, i) => <div key={i} data-index={i} className="animate-float absolute h-2 w-2 rounded-full opacity-60" style={{
        left: `${Math.random() * 100}%`,
        top: `${Math.random() * 100}%`,
        backgroundColor: i % 3 === 0 ? "hsl(35, 90%, 55%)" : i % 3 === 1 ? "hsl(220, 80%, 50%)" : "hsl(180, 70%, 45%)",
        animationDelay: `${Math.random() * 3}s`,
        animationDuration: `${4 + Math.random() * 3}s`
      }} />)}
      </div>

      {}
      <div className="relative z-10 mx-auto max-w-6xl px-4 sm:px-6 lg:px-8">
        {}
        <div ref={headerRef} className={`mb-12 text-center transition-all duration-700 ${headerVisible ? "translate-y-0 opacity-100" : "translate-y-8 opacity-0"}`}>
          <h2 className="mb-4 font-display text-4xl font-bold text-foreground-dark md:text-5xl lg:text-6xl">
            Memorable Event Planning
          </h2>
          <p className="mx-auto max-w-2xl text-lg text-foreground-dark/80 md:text-xl">
            We create unforgettable experiences that bring your vision to life
          </p>
        </div>

        {}
        <div className="grid gap-6 md:grid-cols-2 lg:grid-cols-3">
          {scheduleItems.map((item, i) => {
          const Icon = item.icon;
          const ref = i === 0 ? card1Ref : i === 1 ? card2Ref : card3Ref;
          const isVisible = i === 0 ? card1Visible : i === 1 ? card2Visible : card3Visible;
          return <div key={i} data-index={i} ref={ref} className={`transition-all duration-700 ease-[var(--ease-out-back)] ${isVisible ? "translate-y-0 opacity-100" : "translate-y-12 opacity-0"}`} style={{
            transitionDelay: `${i * 100}ms`
          }}>
                <Card className="group h-full cursor-pointer border border-border/30 glass-effect rounded-xl p-6 shadow-[0_2px_4px_rgba(0,0,0,0.08),0_0_12px_hsl(45,95%,55%)] transition-all duration-[var(--duration-medium)] ease-[var(--ease-spring)] hover:-translate-y-2 hover:shadow-medium">
                  <CardHeader className="p-0 mb-4">
                    <div className="mb-3 flex items-center gap-3">
                      <div className="flex h-12 w-12 items-center justify-center rounded-lg bg-accent/10 transition-colors duration-[var(--duration-medium)] group-hover:bg-accent/20">
                        <Icon className="h-6 w-6 text-accent" strokeWidth={2} />
                      </div>
                      <div className="text-sm font-semibold text-primary">{item.time}</div>
                    </div>
                    <CardTitle className="text-xl font-bold text-foreground">{item.title}</CardTitle>
                  </CardHeader>
                  <CardContent className="p-0">
                    <div className="flex items-center gap-2 text-sm text-muted-foreground">
                      <MapPin className="h-4 w-4 text-secondary" strokeWidth={2} />
                      <span>{item.location}</span>
                    </div>
                  </CardContent>
                </Card>
              </div>;
        })}
        </div>
      </div>

      <style jsx>{`
        @keyframes float {
          0%, 100% {
            transform: translateY(0) rotate(0deg);
          }
          25% {
            transform: translateY(-20px) rotate(90deg);
          }
          50% {
            transform: translateY(-10px) rotate(180deg);
          }
          75% {
            transform: translateY(-30px) rotate(270deg);
          }
        }
        .animate-float {
          animation: float 5s ease-in-out infinite;
        }
      `}</style>
    </section>;
}